import { $Q, $Qll } from 'graditify-utils';

/**
 * Removes styles from specified elements based on their associated checkboxes' checked status.
 *
 * @param {HTMLElement[]} elements - An array of HTMLElements to process.
 */
const restarStylesFilter = (elements) => {
  elements.forEach((tag) => {
    const parent = tag.closest('label');
    const checkbox = $Q('input', parent);

    if (!checkbox.checked) {
      tag.setAttribute('data-checked', 'false');

      const event = new MouseEvent('mouseout', {
        bubbles: true,
        cancelable: true,
        view: window
      });
    
      tag.dispatchEvent(event);
    }
  })
}

/**
 * Change the style of the selected element and trigger style reset for other elements.
 *
 * @param {HTMLElement} currentElement - The element whose style should be changed.
 */
const changeStyleSelected = (currentElement) => {
  const element = currentElement.closest('label');
  const divTag = $Q('.filter-button', element);

  if (currentElement.checked && divTag.dataset.checked === 'false') {
    divTag.setAttribute('data-checked', 'true');
    currentElement.checked = true;

  } else {
    divTag.setAttribute('data-checked', 'false');
    currentElement.checked = false;
  }
  
  restarStylesFilter($Qll('.filter-button'));
}

/**
 * Finds and filters cards based on a given filter.
 *
 * @param {string} filter - The filter string to match against card data.
 * @returns {void}
 */
const findMatchCard = (filter) => {
  const cards = $Qll('.image-item');

  return cards.forEach((card) => {

    const filterCard = card.dataset.filterCard || '';

    if (filterCard.includes(filter)) {
      card.classList.remove('hidden-gw');
  
    } else {
      card.classList.add('hidden-gw');
    
    }
  });

}

/**
 * Find cards that match the selected filter and trigger a function to handle the matching cards.
 *
 * @param {HTMLInputElement} checkbox - The checkbox element representing the selected filter.
 */
const findCardByFilter = (checkbox) => {
  const filterSelected = checkbox.value;

  if (checkbox.checked) {
    findMatchCard(filterSelected); 
    return;
  }

  restarFilter();
}

/**
 * Removes the 'hidden-gw' class from all elements with the 'image-item' class.
 * This function is used to reset a filter that hides certain elements.

 * @returns {void}
 */
const restarFilter = () => {
  const cards = $Qll('.image-item');

  cards.forEach(card => card.classList.remove('hidden-gw'));
}

/**
 * Load event listeners for radio input elements to handle changes in selection.
 */
const loadFilterEventChange = () => {
  const checkboxs = $Qll('input[type=radio]');

  checkboxs.forEach((checkbox) => {
    checkbox.addEventListener('click', () => {
      changeStyleSelected(checkbox);
      findCardByFilter(checkbox);
    })
  })
}

/**
 * Order the cards based on their data-index attribute and update the container's content.
 */
const orderCards = () => {
  const cards = $Qll('.image-item');
  const container = $Q('.container-js');

  const orderCards =  [...cards].sort((a, b) => {
    const numberA = parseInt(a.getAttribute('data-index'));
    const numberB = parseInt(b.getAttribute('data-index'));
    return numberA - numberB;
  });

  container.innerHTML = '';
  orderCards.forEach((card) => {
    container.appendChild(card);
  })
}

export const initialLoadFilter = () => {
  loadFilterEventChange();
  orderCards();
}
